module.exports = __webpack_public_path__ + "img/fennel-seeds.5ebbb746.jpg";